import { getBaseRateSet, getPriceByKey } from "./constructor_pricing.js";
import { isConstructorProject } from "./constructor_state.js";

export function buildConstructorItems(state) {
  const items = [];

  if (!isConstructorProject(state)) {
    const rate = getBaseRateSet(state.projectCategoryKey, state.projectType);

    if (rate.uah > 0 || rate.eur > 0) {
      items.push({
        label: state.projectTypeLabel,
        uahPerSqm: rate.uah,
        eurPerSqm: rate.eur,
        area: state.area,
        quantity: 1,
      });
    }

    return items;
  }

  if (state.planningSelection.checked && state.planningSelection.quantity > 0) {
    const price = getPriceByKey(state.planningSelection.priceKey, state.projectCategoryKey);
    items.push({
      label: buildQuantityLabel(state.planningSelection.label, state.planningSelection.quantity),
      uahPerSqm: price.uah,
      eurPerSqm: price.eur,
      area: state.area,
      quantity: state.planningSelection.quantity,
    });
  }

  if (state.partialSelection.checked) {
    const price = getPriceByKey(state.partialSelection.priceKey, state.projectCategoryKey);
    items.push({
      label: state.partialSelection.label,
      uahPerSqm: price.uah,
      eurPerSqm: price.eur,
      area: state.resolvedPartialArea,
      quantity: 1,
    });
  }

  state.singleDraws.forEach((item) => {
    if (!item.checked) return;

    const price = getPriceByKey(item.priceKey, state.projectCategoryKey);
    const area = item.isRazvortky ? state.resolvedRazvortkyArea : state.area;

    items.push({
      label: item.label,
      uahPerSqm: price.uah,
      eurPerSqm: price.eur,
      area,
      quantity: 1,
    });
  });

  if (state.specificationSelection.checked) {
    const price = getPriceByKey(state.specificationSelection.priceKey, state.projectCategoryKey);
    items.push({
      label: state.specificationSelection.label,
      uahPerSqm: price.uah,
      eurPerSqm: price.eur,
      area: state.area,
      quantity: 1,
    });
  }

  return items;
}

function buildQuantityLabel(label, quantity) {
  return `${label} × ${quantity}`;
}
